import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const css = {
  disabledButtonDefault: {
    backgroundColor: '#a7aca7',
    borderRadius: '5px',
    color: '#777f81',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
    cursor: 'not-allowed',
  },
  buttonDefault: {
    backgroundColor: '#33a9d5',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
  },
  tabButtonDefault: {
    backgroundColor: '#33a9d5',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
    // width: 'calc(11vw + 10px)'
  },
  tabButtonDefaultSelected: {
    backgroundColor: '#90bfe0',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
    // width: 'calc(11vw + 10px)'
  },
  buttonCloseModal: {
    backgroundColor: '#ffffff',
    color: 'rgb(53, 57, 71)',
    fontWeight: 'bold',
    padding: '5px',
    margin: '10px 5px',
    borderRadius: '3px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.3)',
    fontFamily: 'Gadugi',
    width: '75px',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
  },
  buttonRejected: {
    backgroundColor: '#c02a31',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
  },
  buttonRejectedOrange: {
    backgroundColor: '#F18D2D',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
  },
  buttonValidation: {
    backgroundColor: '#9dbf42',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
  },
  buttonValidationNoMargin: {
    backgroundColor: '#9dbf42',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '0',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '10px',
  },
  buttonDisabled: {
    backgroundColor: 'rgba(147,147,147,0.8)',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    pointerEvents: 'none',
    padding: '10px',
  },
  smallDefaultButton: {
    backgroundColor: '#33a9d5',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    height: '30px',
    fontSize: '13px',
    padding: '10px',
  },
  mediumDefaultButton: {
    backgroundColor: '#33a9d5',
    borderRadius: '5px',
    color: '#ffffff',
    margin: '10px',
    fontWeight: 'bold',
    minHeight: '35px',
    height: '56%',
    maxHeight: '45px',
    padding: '20px',
  },
  buttonDelete: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: '#bb0060',
    height: '20px',
    margin: '5px',
  },
  buttonAdd: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: '#33a9d5',
    height: '20px',
    margin: '5px',
  },
  buttonIcon: {
    backgroundColor: '#33a9d5',
    color: '#ffffff',
    borderRadius: '50%',
    minWidth: 35,
    height: 35,
    margin: 8,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
  },
  buttonLabel: {
    fontSize: 'max(0.55vw, 14px)',
  },
};

const MyButton = (props) => {
  const { disabled } = props;

  return (
    <Button type={props.type} sx={props.sx} color={props.color ? props.color : 'primary'}
            style={props.style ? css[props.style] : !disabled ? css.buttonDefault : css.disabledButtonDefault}
            onClick={props.onClick != null && !disabled ? props.onClick : null}>
      {
        props.icon && typeof props.icon === 'string' &&
        <i className={props.icon} style={{ margin: '10px' }} />
      }
      {
        props.icon && typeof props.icon === 'object' &&
        <FontAwesomeIcon icon={props.icon}
                         style={{ height: '20px', marginRight: props.iconOnly ? '0' : '10px', ...props.iconStyle }} />
      }
      <span style={css.buttonLabel}>{props.label}</span>
    </Button>
  );
};

export default MyButton;
